// extracted by mini-css-extract-plugin
module.exports = {"Container":"Items_Container__3MCi0","ReactTable":"Items_ReactTable__23d0V"};